(() => {
  angular
    .module('app')
    .component('hostCorporatesSupportPlansCreateEditBasicsHospitalizationComponent', {
      templateUrl: require('./hospitalization.component.html'),
      controller: BasicsHospitalizationComponentController,
      controllerAs: 'vm',
      bindings: {
        supportPlan: '<',
        availableDependentTypes: '<',
        dependentsCovered: '=',
        masterPolicy: '<',
      },
    });

  BasicsHospitalizationComponentController.$inject = ['$sce', 'Hms.BenefitGroups.DependentType'];

  function BasicsHospitalizationComponentController($sce, enumDependentType) {
    const vm = this;
    vm.daysText = App.localize('Days');
    vm.yearsText = App.localize('Year');
    vm.deliveryText = App.localize('Delivery');
    vm.illnessInfo = App.localize('SpecifiedIllnessTooltip');

    // Feature flag.

    vm.hasHospitalizationWaitingPeriodEnhancement = abp.setting.getBoolean(
      'Hms.Feature.HospitalisationWaitingPeriodEnhancement'
    );

    vm.displaySafeHtml = displaySafeHtml;
    vm.toggleHospitalizationBasics = toggleHospitalizationBasics;
    vm.toggleDependentsCovered = toggleDependentsCovered;
    vm.isAdmittedByPolicy = isAdmittedByPolicy;
    vm.$onInit = init;
    vm.$onChanges = onChanges;

    function init() {
      vm.toggleHospitalizationBasics();
      vm.dependentModel = {};
      (vm.dependentsCovered || []).forEach((val) => {
        vm.dependentModel[val] = true;
      });
      refreshPolicyDependantRules();
    }

    function onChanges(changes) {
      if (changes.masterPolicy || changes.availableDependentTypes) {
        refreshPolicyDependantRules();
      }
    }

    function displaySafeHtml(html) {
      return $sce.trustAsHtml(html);
    }

    function toggleHospitalizationBasics() {
      vm.minAccidentDays = vm.supportPlan.hospitalizationSetting.isAccidentAdmission === 1 ? 1 : 0;
      vm.minIllnessDays = vm.supportPlan.hospitalizationSetting.isIllnessAdmission === 1 ? 1 : 0;
      vm.minPreExistingDays = vm.supportPlan.hospitalizationSetting.isPreExisting === 1 ? 1 : 0;
      vm.minNonAccidentalIllnessDays =
        vm.supportPlan.hospitalizationSetting.isNonAccidentalIllness === 1 ? 1 : 0;
    }

    function toggleDependentsCovered(value) {
      const isChecked = vm.dependentModel[value];
      const idx = vm.dependentsCovered.indexOf(value);

      if (isChecked && idx === -1) {
        vm.dependentsCovered.push(value);
      } else if (!isChecked && idx > -1) {
        vm.dependentsCovered.splice(idx, 1);
      }
    }

    // Master policy dependant enrolment rules, shown beside the "cover dependants" option so the
    // operator can see when the plan contradicts the policy (HM-11196). A relationship is refused
    // only when the policy has a rule for it that is not covered or has a maximum entry age of 0;
    // a relationship without a rule is admitted. Mirrors DependentHospitalizationEntitlement on the
    // server and the policy holder import. Plans without a policy show nothing.

    function refreshPolicyDependantRules() {
      vm.policyDependantRules = null;
      vm.policyRefusedRelationships = [];
      vm.policyAdmitsNoDependants = false;
      vm.policyAdmittedText = '';

      const rules = ((vm.masterPolicy || {}).enrolmentRules || []).filter((r) => !r.isPrincipal);
      if (!rules.length) {
        return;
      }

      const isAdmitted = (r) => r.isCovered !== false && r.maxEntryAge > 0;
      const admitted = rules.filter(isAdmitted);

      vm.policyDependantRules = rules;
      vm.policyRefusedRelationships = rules
        .filter((r) => !isAdmitted(r))
        .map((r) => (r.relationship || '').toLowerCase());
      const types = vm.availableDependentTypes || [];
      vm.policyAdmitsNoDependants =
        types.length > 0 && types.every((t) => !isAdmittedByPolicy(t.value));
      vm.policyAdmittedText = admitted
        .map((r) =>
          App.localize('RelationshipEntryAgeRange', r.relationship, r.minEntryAge, r.maxEntryAge)
        )
        .join(', ');
    }

    function isAdmittedByPolicy(dependentTypeValue) {
      if (!vm.policyDependantRules) {
        return true;
      }

      const item = (enumDependentType.values || []).find((x) => x.id === dependentTypeValue);
      if (!item || !item.name) {
        return true;
      }

      return vm.policyRefusedRelationships.indexOf(item.name.toLowerCase()) === -1;
    }
  }
})();
